module.exports = __webpack_public_path__ + "static/media/danone.b042bddb.png";